import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/pages/startpage/src/assets/cover-letter-bg.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')